import { forwardRef } from 'react';
import { LoaderCircle } from 'lucide-react';
import { cn } from '@/lib/cn';

const TAMANHOS = {
  sm: 'h-4 w-4',
  default: 'h-5 w-5',
  lg: 'h-8 w-8',
} as const;

export interface SpinnerProps extends React.HTMLAttributes<HTMLSpanElement> {
  tamanho?: keyof typeof TAMANHOS;
  /**
   * Texto lido por leitor de tela. String vazia torna o spinner decorativo —
   * use dentro de botão, onde o próprio rótulo do botão já anuncia a ação e
   * um segundo "Carregando" só duplicaria a fala.
   */
  rotulo?: string;
}

const Spinner = forwardRef<HTMLSpanElement, SpinnerProps>(
  ({ className, tamanho = 'default', rotulo = 'Carregando', ...props }, ref) => {
    const decorativo = rotulo === '';
    return (
      <span
        ref={ref}
        role={decorativo ? undefined : 'status'}
        aria-hidden={decorativo || undefined}
        className={cn('inline-flex items-center justify-center text-current', className)}
        {...props}
      >
        <LoaderCircle className={cn('animate-spin', TAMANHOS[tamanho])} aria-hidden="true" />
        {decorativo ? null : <span className="sr-only">{rotulo}</span>}
      </span>
    );
  },
);

Spinner.displayName = 'Spinner';

export { Spinner };
